export default __webpack_public_path__ + "static/media/check.ed3ec6e8.svg";